// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button{display:block;border-radius:0;background-color:#000;color:#fff;padding:.5rem 2.5rem;transition-duration:.3s;border:1px solid #000}.button:hover{border-radius:.7rem}.button.member-email,.button:hover{color:#000;background-color:#fff}.button.member-email span{white-space:pre}.button.member-email:hover{color:#fff;background-color:#000}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
